export const INBOUND = 'INBOUND';
export const OUTBOUND = 'OUTBOUND';
export const INTERNAL = 'INTERNAL';
